import { IssueQuickLinks } from '../../../cimsPage/instances/issues'
import { QuickLinks } from '../../common'

const { Create, Edit, RemoveRestore, View } = QuickLinks({
  page: IssueQuickLinks,
  create: 'aa5cb2ad-7aea-4e1b-9a23-089458499a9b',
  edit: '8674a227-5db7-4324-a903-97b52d2d5bec',
  removeRestore: '71a9ddd0-1a24-42fc-8f99-c5802ef44a56',
  view: '3151994c-ef50-4463-8ebe-7f0d18bc0f4a',
})

export const CreateIssueQuickLink = Create
export const EditIssueQuickLink = Edit
export const RemoveRestoreIssueQuickLink = RemoveRestore
export const ViewIssueQuickLink = View

export type IssueQuickLinkPermission =
  | typeof CreateIssueQuickLink
  | typeof EditIssueQuickLink
  | typeof RemoveRestoreIssueQuickLink
  | typeof ViewIssueQuickLink
